"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const gridBlocks = [{
  title: "Herramientas que no hablan.",
  description: "CRM, ERP, hojas de cálculo, formularios. Cada sistema vive en su isla. Los datos se duplica, se pierde, se desactualiza.",
  iconUrl: "https://solid-eft.10web.cloud/wp-content/uploads/2026/04/fulcro-icon-integracion.svg",
  iconAlt: "Sistemas que no se integran"
}, {
  title: "Trabajo manual repetitivo.",
  description: "Tu equipo invierte horas en tareas que tienen patrón claro: copiar, pegar, transcribir, conciliar, reportar.",
  iconUrl: "https://solid-eft.10web.cloud/wp-content/uploads/2026/04/fulcro-icon-automatizacion.svg",
  iconAlt: "Automatización ausente"
}, {
  title: "Visibilidad que llega tarde.",
  description: "Te enteras de los problemas cuando ya son problemas. Los reportes ejecutivos viven en Excel y dependen de que alguien los actualice.",
  iconUrl: "https://solid-eft.10web.cloud/wp-content/uploads/2026/04/fulcro-icon-datos.svg",
  iconAlt: "Datos que llegan tarde"
}];
export default function ElProblema() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: areCardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223886" id="el-problema" className="bg-background py-24 md:py-32 overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-6 flex flex-col gap-12 lg:gap-20">
        <div ref={textRef} className={`transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-serif font-normal text-foreground mb-8 max-w-4xl leading-tight">
            Tu operación creció más rápido que tus procesos.
          </h2>
        </div>

        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 transition-all duration-1000 delay-200 ease-out ${areCardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {gridBlocks.map((block, i) => <Card key={i} data-index={i} className="bg-transparent border-none shadow-none rounded-none border-l-2 border-l-muted-foreground/30 py-0">
              <CardHeader className="pb-4 px-6">
                <div className="mb-6 mx-auto">
                  <img src={block.iconUrl} className="w-12 h-12 object-contain" alt={block.iconAlt} />
                </div>
                <CardTitle className="text-2xl font-serif font-normal text-foreground leading-tight">
                  {block.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-6">
                <p className="text-muted-foreground leading-relaxed font-sans text-base">
                  {block.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}